import { render, staticRenderFns } from "./Introduction.vue?vue&type=template&id=56d363b6&scoped=true&"
import script from "./Introduction.vue?vue&type=script&lang=ts&"
export * from "./Introduction.vue?vue&type=script&lang=ts&"
import style0 from "./Introduction.vue?vue&type=style&index=0&id=56d363b6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d363b6",
  null
  
)

export default component.exports